<template>
  <label class="select-box">
    <span v-if="labelText" class="iw-body-text-small select-box__label">{{ labelText }}</span>
    <select class="select p-l-10" @change="handleSelectionChange">
      <slot></slot>
      <option v-if="hasDefaultOptionNull" :key="null" :selected="hasDefaultOptionNull" :value="null"> </option>
      <option
        v-for="(option, index) in options"
        :key="option.id || index"
        :selected="selected === option.id"
        :value="String(option.id) || option.value"
      >
        {{ option.name || option.value }}
      </option>
    </select>
  </label>
</template>

<script>
export default {
  name: "AppSelectBox",
  props: {
    options: Array,
    labelText: String,
    onChangeCb: Function,
    selected: [Number, String],
    hasDefaultOptionNull: Boolean,
    defaultOptionText: String
  },
  methods: {
    handleSelectionChange(event) {
      if (this.onChangeCb) {
        this.onChangeCb(event);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dark {
  .select {
    background-color: $background-dark--1;
    color: $primary-color;
  }
}

.select-box {
  display: flex;
  flex-direction: column;
  font-family: $fontFamilyPrimary;
  font-size: 14px;
  border: none;
  &__label {
    height: 33.8px;
  }
}

.select {
  height: 46px;
  width: 100%;
  outline: none;
  border-radius: 2px;
  border: solid 1px rgba(141, 154, 174, 0.4);
  appearance: none;
  background-color: $group-3-color-1;
  background-image: url("data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMzY1IDM2NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTQ1LjUgMTk4LTEyNi4wMS0xMzAuNWgyNTIuMDFsLTEyNi4wMSAxMzAuNXoiIGZpbGw9IiM4RDlBQUUiLz48L3N2Zz4=");
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 60%, 0 0;
  background-size: 13px auto, 100%;
}
</style>
